import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './styles/globals.scss';
import { AuthProvider } from './context/useAuth';
import { SocketProvider } from './context/useSocket';
import { ChatNotificationsProvider } from './features/chat/context/useChatNotifications';
import { RequestNotificationsProvider } from './features/therapyOccurrenceRequests/context/useRequestNotifications';
import { ConfigProvider } from 'antd';
import srRS from 'antd/locale/sr_RS';
import antdTheme from './styles/antdTheme';
import { ToastProvider } from './shared/hooks/useToast';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/sr';

dayjs.extend(updateLocale);
dayjs.locale('sr');
dayjs.updateLocale('sr', {
  weekStart: 1,
  weekdaysMin: ['Ne', 'Po', 'Ut', 'Sr', 'Če', 'Pe', 'Su'],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider locale={srRS} theme={antdTheme}>
      <ToastProvider>
        <BrowserRouter>
          <AuthProvider>
            <SocketProvider>
              <ChatNotificationsProvider>
                <RequestNotificationsProvider>
                  <App />
                </RequestNotificationsProvider>
              </ChatNotificationsProvider>
            </SocketProvider>
          </AuthProvider>
        </BrowserRouter>
      </ToastProvider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
